import { useEffect, useRef } from 'react'
import { isMobile } from 'react-device-detect'
const useScrollToTop = (scrollOffset: number) => {
  const componentRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (componentRef.current && isMobile) {
      const topPosition =
        componentRef.current.getBoundingClientRect().top +
        window.scrollY -
        scrollOffset
      window.scrollTo({
        top: topPosition,
        behavior: 'instant',
      })
    }
  }, [scrollOffset])

  return componentRef
}

export default useScrollToTop
